(ns app.agenda.page
  "The agenda view — story cards grouped by day."
  (:require [app.agenda.home :as home]
            [ui.account-selector :as account-selector]
            [ui.user-session :as user-session]))

(defn- day-section [state day-key posts]
  (let [date (:post-date (meta day-key))]
    [:div
     {:class ["bg-white" "rounded-lg" "p-3" "shadow-sm" "border" "border-gray-200"]
      :replicant/key (str day-key)}
     [:div
      {:class ["pb-2"]}
      [:h3
       {:class ["text-xs" "sm:text-sm" "font-bold" "text-gray-900"]}
       (home/format-date date)]]
     [:div
      {:class ["flex" "flex-wrap" "gap-2" "sm:gap-3"]}
      (map (fn [post]
             [:div
              {:class ["w-24" "sm:w-28" "md:w-32"]
               :replicant/key (:db/id post)}
              (home/story-card state post)])
           posts)]]))

(defn- agenda-content [state result]
  (let [posts (:agenda/posts result)
        grouped (when (seq posts) (home/group-posts-by-day posts))
        accounts (or (:schedule/accounts result)
                     (:instagram/users result))
        account-connected? (boolean
                             (some account-selector/connected? accounts))]
    [:div
     {:class ["space-y-4"]}
     (home/date-nav state)
     (if (seq grouped)
       [:div
        {:class ["flex" "flex-wrap" "gap-4" "sm:gap-6"]}
        (map (fn [[day-key day-posts]]
               (day-section state day-key day-posts))
             grouped)]
       (home/empty-schedule account-connected?
                            (user-session/org-uuid state)))]))

(defn render [state]
  (home/schedule-shell state :agenda agenda-content))

(def page
  {:page-id :pages/agenda
   :route [["ui" "agenda"]]
   :on-load (fn [_location] home/on-load-actions)
   :render #'render})
